import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-klarna-express-button-wrapper',
    templateUrl: './klarna-express-button-wrapper.component.html'
})
export class KlarnaExpressButtonWrapperComponent {
}
